import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "white",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M3 9v6h4l5 5V4L7 9H3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 9.5a4.5 4.5 0 010 5",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 7.5a7 7 0 010 9",
  fill: "none"
})), 'Unmuted', {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24'
});